const LIMIT_LABELS: Record<string, string> = {
    attendants: 'atendentes',
    landingPages: 'landing pages',
};

export function getPlanErrorMessage(error: any, fallback: string) {
    const data = error?.response?.data;

    if (data?.code === 'PLAN_LIMIT_REACHED') {
        const limitLabel = LIMIT_LABELS[data?.limitKey] || 'recursos';
        const limitSuffix = data?.limit ? ` Limite atual: ${data.limit}.` : '';
        return `${data?.message || `Limite de ${limitLabel} atingido para o plano atual.`}${limitSuffix}`;
    }

    if (data?.code === 'PLAN_FEATURE_BLOCKED') {
        return data?.message || 'Este recurso nao esta disponivel no seu plano atual.';
    }

    return data?.message || fallback;
}
